export * from './equipment-create.component';
export * from './equipment-create.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-create/index.ts